module.exports = __webpack_public_path__ + "img/createcourse.ad18a524.png";